// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jO7Oy","textarea":"styles_textarea__2-yJM"};